// Au clic sur une ancre, en version mobile (écrans < 1024px), décalage du scroll de 70px
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {

    if (window.innerWidth >= 1024) return;

    const target = document.querySelector(this.getAttribute('href'));
    if (!target) return;

    e.preventDefault();

    const offset = 70;

    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  });
});